import { Component, OnInit } from '@angular/core';
import { NotificationServiceService } from './../../../../../../services/notification-service/notification-service.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { RegistrosService } from './../../../../../../services/API/registros/registros.service';
import { GenerarDocumentoService } from './../../../../../../services/generar-documento.service';
import { StorageService } from './../../../../../../services/API/storage/storage.service';
import { NewRegistroComponent } from './components/new-registro/new-registro.component';
import { ConfirmDialogComponent } from './../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { Router } from '@angular/router';
import { AuthService } from './../../../../../../services/API/auth/auth.service';
import { Location } from '@angular/common';

@Component({
    selector: 'app-clasificacion',
    templateUrl: './clasificacion.component.html',
    styleUrls: ['./clasificacion.component.css'],
    standalone: false
})
export class ClasificacionComponent implements OnInit {

  albaran: number;
  showProgressBar: boolean = false;
  foto;
  clasificacion: any = [];
  errorPesajes: boolean = false;

  constructor(private route: ActivatedRoute, public authService: AuthService, private dialog: MatDialog, private notificationService: NotificationServiceService, private registrosService: RegistrosService
              ,  private storageService: StorageService, private documento: GenerarDocumentoService, public router: Router, private location: Location) { }

  ngOnInit(): void {
    this.userRolCheck('permiso_clasificar');
    this.albaran = parseInt(this.route.snapshot.paramMap.get("id"));
    if(this.albaran > 0){
      this.getDatosRegistro();
    }
  }

  userRolCheck(permission: string){
    if(!this.authService.userRolCheck(permission)) {
      this.authService.logout();
    }
  }

  getDatosRegistro() {
    this.showProgressBar = true;
    this.registrosService.getDatosRegistro(this.albaran,'false').subscribe(result => {
      this.showProgressBar = false;
      this.processPesajesResiduos(result);
    });
  }

  newRegistro(id: number) {
    const newNivelDialog = this.dialog.open(NewRegistroComponent, {
      width: '90%',
      maxWidth: '500px'
    });
    newNivelDialog.afterClosed().subscribe(result => {
      if(result){
        this.showProgressBar = true;
        this.registrosService.newClasificacion(this.albaran, id.toString(),result["material"], result["peso"], result["observaciones"], result["foto1"], result["foto2"]).subscribe(() => {
          this.notificationService.openSnackBar("Registro creado correctamente!");
          this.showProgressBar = false;
          this.ngOnInit();
        });
      }
    });
  }

  processPesajesResiduos(data: any){
    /* Primero miramos que no haya ningun residuo con más de 2 pesajes */
    var error = false;
    for(var i=0; i<data.length; i++){
      var countElements = 0;
      for(var j=0; j<data.length; j++){
        if(data[i]['id_material'] === data[j]['id_material']){
          countElements++
        }
      }
      if(countElements > 2){
        error = true;
        break;
      }
    }
    if(error === true){
      /* Si hay algun material con mas de 2 pesajes mostramos error y no dejamos generar el documento */
      this.errorPesajes = true;
    }else{
      /* Si todo está OK */
      this.errorPesajes = false;
      this.clasificacion = [];
      //
      var hechos = [];
      for(var k=0; k<data.length; k++){
        if(hechos.includes(data[k]['id_material']) === false ){
          hechos.push(data[k]['id_material']);
          var residuo: string = '';
          var id_residuo: number = -1;
          var peso1: number = -1;
          var peso2: number = -1;
          for(var l=0; l<data.length; l++){
            if(data[k]['id_material'] === data[l]['id_material']){
              if(residuo.length === 0){
                residuo = data[l]['material'];
                id_residuo = data[l]['id_material'];
                peso1 = data[l]['peso'];
              }else{
                peso2 = data[l]['peso'];
              }
            }
          }
          if(peso2 === -1){
            peso2 = 0;
            var neto = peso1 - peso2;
            this.clasificacion.push({id_residuo: id_residuo, residuo: residuo, peso1: this.puntuarPeso(peso1.toString()), peso2: this.puntuarPeso(peso2.toString()), neto: this.puntuarPeso(neto.toString()), clasificado: data[k]['clasificado']});
          }else{
            if(peso1 < peso2){
              var peso11 = peso1;
              var peso22 = peso2;
              peso1 = peso22;
              peso2 = peso11;
              var neto = peso1 - peso2;
              this.clasificacion.push({id_residuo: id_residuo, residuo: residuo, peso1: this.puntuarPeso(peso1.toString()), peso2: this.puntuarPeso(peso2.toString()), neto: this.puntuarPeso(neto.toString()), clasificado: data[k]['clasificado']});
            }else{
              var neto = peso1 - peso2;
              this.clasificacion.push({id_residuo: id_residuo, residuo: residuo, peso1: this.puntuarPeso(peso1.toString()), peso2: this.puntuarPeso(peso2.toString()), neto: this.puntuarPeso(neto.toString()), clasificado: data[k]['clasificado']});
            }
          }
        }
      }
    }
  }

  puntuarPeso(peso: string) {
    return peso.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
  }

  finalizarClasificacion(){
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {title: 'Finalizar clasificación', body: '¿Seguro que deseas finalizar el clasificado?'},
      width: '90%',
      maxWidth: '350px'
    });
    confirmDialog.afterClosed().subscribe(result => {
      if(result["accion"] === 'true'){
        this.showProgressBar = true;
        this.registrosService.clasificarAlbaran(this.albaran.toString(), 'true').subscribe(() => {
          this.notificationService.openSnackBar("¡Albarán clasificado correctamente!");
          this.showProgressBar = false;
          this.router.navigateByUrl('/clasificar-registros');
        }, error => {
          this.notificationService.openSnackBar("¡Se ha producido un error!");
          this.showProgressBar = false;
        });
      }
    });
  }

  back(){
    this.location.back();
  }

}
